import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../../translation/translation';

export const Section = props => (
    <div
        className={'lightbox-overview-section lightbox-overview-section--' + props.sectionName}
        onClick={() => props.openView(props.sectionType)}
    >
        <Translation
            tagName="h3"
            className="lightbox-overview-section__headline"
            translationKey={props.translationKey}
        />
    </div>
);

Section.propTypes = {
    sectionType: PropTypes.string.isRequired,
    sectionName: PropTypes.string.isRequired,
    openView: PropTypes.func.isRequired,
    translationKey: PropTypes.string.isRequired,
};
